/**
 * @param {number} ms
 */
const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

/**
 * Retry async function n number of times
 *
 * @param {Promise<T>} fn Function to execute
 * @param {number} maxAttempts Max number of attempts
 * @param {number} backoff Backoff in milliseconds
 * @param {number} [factor=0] Factor used to exponetially increase backoff. Default 0.
 * @param {number} [maxDelay=10000] Max backoff delay in milliseconds. Default 10000.
 * @return {Promise<T>}
 */
async function retry<T>(
  fn: () => Promise<T>,
  maxAttempts: number,
  backoff: number,
  factor: number = 0,
  maxDelay: number = 10000,
): Promise<T> {
  let lastError: any;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn();
    } catch (e) {
      lastError = e;
    }

    let nextBackoff = backoff;
    if (factor >= 1) {
      nextBackoff = Math.round(backoff * Math.pow(factor, attempt));
    }

    await delay(Math.min(maxDelay, nextBackoff));
  }
  throw lastError;
}

export { delay, retry };
